import '../../vendor/clickmenu.js';

export const setupMenu = ($: JQueryStatic) => {
  const toggleMenu = document.querySelector('.toggle-menu');
  const closeMenu = document.querySelector('.close-menu');
  const mainNav = document.querySelector('.main-nav.nav-bar');

  if (toggleMenu && mainNav) {
    toggleMenu.addEventListener('click', () => {
      document.body.classList.toggle('cm-js-menu-active');
      mainNav.classList.toggle('cm-js-active');
    });
  }

  if (closeMenu && mainNav) {
    closeMenu.addEventListener('click', () => {
      document.body.classList.remove('cm-js-menu-active');
      mainNav.classList.remove('cm-js-active');
    });
  }

  $('.main-nav').clickMenu({ landings: false, expanders: false });
  $('.nav-rail').clickMenu({ menutype: 'accordion', expanders: true });
};
